var map = {
	"./arrow.png": 48,
	"./horno.png": 147,
	"./icons8-cerdo-48.png": 63,
	"./icons8-cerdo-50.png": 148,
	"./icons8-cow-breed-60.png": 64,
	"./icons8-facebook-96.png": 65,
	"./icons8-oveja-50.png": 66,
	"./icons8-pollo-50.png": 67,
	"./icons8-telefono-de-oficina-100.png": 68,
	"./icons8-vaca-50.png": 149,
	"./olla.png": 150,
	"./parrilla.png": 151,
	"./phone.png": 152,
	"./phone2.png": 153,
	"./phone3.png": 69,
	"./sartén.png": 154
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 43;